import React, { Dispatch, FC } from "react";
import MenuSectionEditBox from "components/menu/ui/MenuSectionEditBox";
import { Box, Stack } from "@mui/material";
import PillButton from "components/common/ui/PillButton";
import { FoodItem } from "client/jspPlatformExperiment";
import {
  MenuContentAction,
  TypeDisplayMenuSections,
} from "models/menu/menuContentsReducer";
import useMenuOptionActions from "hooks/menu/useMenuOptionActions";

export interface MenuContentEditSectionProps {
  foodItemOptions: FoodItem[];
  menuContents: TypeDisplayMenuSections;
  dispatchMenuContents: Dispatch<MenuContentAction>;
}

const MenuContentsEditSection: FC<MenuContentEditSectionProps> = ({
  foodItemOptions,
  menuContents,
  dispatchMenuContents,
}) => {
  const { handleAdd } = useMenuOptionActions(
    menuContents,
    dispatchMenuContents,
    "",
  );

  return (
    <Stack spacing={1}>
      {Object.keys(menuContents).map((sectionKey) => (
        <MenuSectionEditBox
          key={sectionKey}
          displayMenuOptionUUIDPath={sectionKey}
          menuContents={menuContents}
          dispatchMenuContents={dispatchMenuContents}
          foodItemOptions={foodItemOptions}
        />
      ))}
      <Box sx={{ alignSelf: "center" }}>
        <PillButton
          text="Add menu section"
          onClick={handleAdd("option group")}
        />
      </Box>
    </Stack>
  );
};

export default MenuContentsEditSection;
